import { getCostAnomalyPreviewRequestArgsSelector } from "./getCostAnomalyPreviewRequestArgsSelector";
import { getCostAnomalyPreviewDataGridDataSelector } from "./getCostAnomalyPreviewDataGridDataSelector";
import { RootState } from "../../../store";
import { ResourceExplorerDataAverage } from "../../../../services/cloudchipr.api";

export const costAnomalyPreviewDataGridDataSelector = (
  state: RootState,
): ResourceExplorerDataAverage[] | null => {
  const args = getCostAnomalyPreviewRequestArgsSelector(state);

  if (!args) {
    return [];
  }

  return (
    getCostAnomalyPreviewDataGridDataSelector(args)(state)?.data?.map(
      (item, index) => {
        return {
          ...item,
          id: item.field + item.average_cost + item.cloud_provider + index,
        };
      },
    ) ?? null
  );
};
